import { Button, View, Card, CardContent, Skeleton } from "@/components/ui";
import { PackageCard } from "@/components/shared/package-card";
import { HorizontalScroll } from "@/components/shared/horizontal-scroll";
import { Typography } from "@/components/shared/typography";
import NoPackages from "@/assets/images/3d-illus/no-packages.png";
import { EmptyCard } from "@/components/shared/empty-card";
import { useRoute } from "@/components/shared/router";
import { usePackagesByFiltersQuery } from "@/gqlhooks/packages/usePackagesByFiltersQuery";
import { useWindowDimensions } from "@/components/hooks/use-window-dimension";
import { PackageStatusEnum } from "@/__generated__/graphql";

export function PackageListOverview() {
  const { list: packageList, loading } = usePackagesByFiltersQuery({
    limit: 3,
    status: PackageStatusEnum.Active,
  });
  const { isMobile, width } = useWindowDimensions();
  const cardWidth = Math.floor(width * 0.8);
  const { push } = useRoute();
  return (
    <View className="flex flex-col gap-3">
      <View className="flex flex-row items-center justify-between px-4">
        <Typography variant="label-md">Active Packages</Typography>
        <Button
          variant="secondary"
          color="CTA2"
          size="sm"
          onClick={() => {
            push({
              pageKey: "packages",
            });
          }}
        >
          View All
        </Button>
      </View>
      {loading ? (
        <View className="px-4 pb-4 md:px-0">
          <Card className="flex-1" shadow="sm">
            <CardContent className="px-3 py-3">
              <View className="mb-3 flex w-full flex-row items-start justify-between gap-3 border-b border-secondary-border">
                <View className="flex w-full flex-1 flex-row items-start justify-between pb-2 md:items-center">
                  <Skeleton className="h-4 w-32" />
                  <Skeleton className="h-5 w-16 rounded-full" />
                </View>
              </View>
              <View className="flex flex-row items-center justify-between md:items-end">
                <View className="flex flex-col gap-1">
                  <Skeleton className="h-3 w-40" />
                  <Skeleton className="h-3 w-48" />
                </View>
                <View className="flex w-full max-w-[110px] flex-row items-center justify-end gap-1">
                  <Skeleton className="h-3 w-12 rounded-full" />
                </View>
              </View>
            </CardContent>
          </Card>
        </View>
      ) : !packageList.length ? (
        <EmptyCard title="You don't have any Packages" src={NoPackages} />
      ) : isMobile ? (
        <HorizontalScroll
          data={packageList}
          itemSpacing={16}
          contentPadding={{ start: 16, end: 16 }}
          itemWidth={cardWidth}
          snap="start"
          keyExtractor={(item) => item.id}
          renderItem={(item) => <PackageCard item={item} />}
        />
      ) : (
        <View className="flex flex-col gap-4 px-0 pb-4">
          {packageList.map((item) => (
            <View className="min-w-full" key={item.id}>
              <PackageCard item={item} />
            </View>
          ))}
        </View>
      )}
    </View>
  );
}
